'use client';

import './CarModelStyleVariants.scss';
import cn from 'classnames';

import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function CarModelVariants({ activeStyle, itemsJaecooJ7Phev, onSetActiveStyle }) {
  return (
    <ul className={'style-variants'}>
      {itemsJaecooJ7Phev.map((item) => (
        <li
          className={cn(
            'style-variants_item',
            activeStyle.fields.id.value === item.fields.id.value && 'active'
          )}
          key={item.fields.id.value}
          onClick={() => onSetActiveStyle(item)}
        >
          <Image alt="car style" field={item.fields.image} fill className={'style-variants_img'} />
        </li>
      ))}
    </ul>
  );
}
